import { createSlatePlugin } from 'platejs';

import { PLATE_KEYS, SpoilerElement } from 'features/Editor';

export const SpoilerPlugin = createSlatePlugin({
	key: PLATE_KEYS.spoiler,
	node: { isLeaf: true, component: SpoilerElement },
	parsers: {
		html: {
			deserializer: {
				rules: [{ validNodeName: ['SPAN'] }],
				query: ({ element }) => {
					return element.classList.contains('tg-spoiler');
				},
			},
		},
	},
}).extendTransforms(({ editor, type }) => ({
	toggle: () => {
		editor.tf.toggleMark(type);
	},
}));
